if (import.meta.hot) {
  import.meta.hot.accept();
}

import '@assets/Scss/component/cards.scss';
import './menu-carousel.scss';
import Swiper from 'swiper';
import { Navigation, Keyboard } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

const swiperContainers = document.querySelectorAll('.swiper-menu-carousel');

swiperContainers.forEach(swiperContainer => {
  const parentWrapper = swiperContainer.parentElement;
  const btnRow = parentWrapper.querySelector('.cards-btn-row');
  const nextEl = btnRow.querySelector('.swiper-button-next-in');
  const prevEl = btnRow.querySelector('.swiper-button-prev-in');

  const swiper = new Swiper(swiperContainer, {
    modules: [Navigation, Keyboard],

    loop: false,
    effect: 'slide',
    a11y: {
      enabled: true,
      slideRole: 'group',
    },
    slidesPerView: 1.2,
    spaceBetween: 16,

    breakpoints: {
      768: {
        slidesPerView: 1.5,
        spaceBetween: 24,
      },
      992: {
        slidesPerView: 2.5,
        spaceBetween: 24,
      },
      1400: {
        slidesPerView: 2.5,
        spaceBetween: 48,
      },
    },
    navigation: {
      nextEl,
      prevEl,
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
  });

  let isActive = false;

  const activateKeyboard = () => {

    if (!isActive) {
      swiper.keyboard.enable();
      isActive = true;
    }
  };

  const deactivateKeyboard = () => {

    if (isActive) {
      swiper.keyboard.disable();
      isActive = false;
    }
  };
  swiperContainer.addEventListener('focusin', activateKeyboard);
  swiperContainer.addEventListener('focusout', (e) => {
    if (!swiperContainer.contains(e.relatedTarget)) {
      deactivateKeyboard();
    }
  });
  swiperContainer.addEventListener('mouseenter', activateKeyboard);
  swiperContainer.addEventListener('mouseleave', deactivateKeyboard);

  if (nextEl) {
    nextEl.addEventListener('focus', activateKeyboard);
    nextEl.addEventListener('blur', deactivateKeyboard);
  }
  if (prevEl) {
    prevEl.addEventListener('focus', activateKeyboard);
    prevEl.addEventListener('blur', deactivateKeyboard);
  }

  const slides = swiperContainer.querySelectorAll('.swiper-slide');

  slides.forEach((slide, index) => {
    const link = slide.querySelector('a');

    if (link) {
      link.addEventListener('focus', (e) => {
        e.preventDefault();
        activateKeyboard(); // Aktiviere Keyboard
        swiper.slideTo(index, 300);
      }, true);
    }
  });

});
